var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 314,
    viewBox: "0 0 264 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_944_29359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.164 185.335C269.051 172.239 269.051 141.737 248.164 128.641L51.2238 5.13872C29.0101 -8.78632 -0.000427558 7.12801 -0.00042871 33.4861L-0.000429355 48.24L165.442 151.517C173.068 156.159 216.832 186.496 185.004 224.955L248.164 185.335Z",
    fill: "url(#paint0_linear_944_29359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6564 12.9301L51.2233 5.13873C29.0096 -8.78632 -0.00091584 7.12802 -0.000916992 33.4861L-0.000927789 280.49C-0.000928941 306.848 29.0096 322.762 51.2233 308.837L63.6564 301.046L63.6564 91.1756C63.6564 82.2238 61.9987 35.9727 111.399 42.7695L63.6564 12.9301Z",
    fill: "url(#paint1_linear_944_29359)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M63.6263 235.986L63.6263 211.167C23.9457 234.784 0.660244 196.827 -0.00104141 197.483L-0.00104298 233.356L63.6263 235.986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2241 308.837L185.004 224.955C211.196 193.458 186.164 167.266 172.239 156.325L72.609 219.153C55.7 229.929 15.5827 244.02 -0.000123831 196.608L-0.000127527 281.153C0.497201 307.18 29.1761 322.762 51.2241 308.837Z",
    fill: "url(#paint2_linear_944_29359)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M172.248 156.26L164.628 161.131C171.603 165.592 184.327 175.102 189.156 189.31C195.951 209.465 189.459 218.186 184.988 224.959C210.594 193.358 187.335 168.827 172.248 156.26Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M63.7025 88.06C64.8267 38.0967 97.0531 41.5941 111.293 42.8432C74.5196 44.5419 71.6134 78.1506 73.1956 93.8058L63.7025 88.06Z",
    fill: "#654CF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_944_29359",
    x1: 242.543,
    y1: 182.961,
    x2: 16.6364,
    y2: 59.6453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.041858,
    stopColor: "#8974FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2CB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_944_29359",
    x1: 55.6437,
    y1: -0.000277397,
    x2: 55.6437,
    y2: 314.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A58EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#13CDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_944_29359",
    x1: 196.577,
    y1: 202.175,
    x2: 11.118,
    y2: 257.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#6B35C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA7DF3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_944_29359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 313.977,
    height: 263.913,
    fill: "white",
    transform: "translate(263.912) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.b7e5693fab737055b4fd4372b1d53362.svg";
export { ForwardRef as ReactComponent };